import type { SatelliteContactSiteStats } from "@shopexperts/legacy-api";

const dateTimeFormatter = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
    timeStyle: "short",
});

export function formatSatelliteDate(value: string | null | undefined): string {
    if (!value) return "Never";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return "Unknown";
    return dateTimeFormatter.format(parsed);
}

export function formatSubmissionCount(count: number): string {
    if (count === 0) return "No submissions";
    if (count === 1) return "1 submission";
    return `${count.toLocaleString()} submissions`;
}

export function formatStatLabel(key: keyof SatelliteContactSiteStats): string {
    switch (key) {
        case "all_time":
            return "All time";
        case "last_30_days":
            return "Last 30 days";
        case "last_month":
            return "Last month";
        case "this_month":
            return "This month";
        default:
            return key;
    }
}

export const STAT_KEYS: readonly (keyof SatelliteContactSiteStats)[] = [
    "this_month",
    "last_month",
    "last_30_days",
    "all_time",
];
